module.exports = __webpack_public_path__ + "static/media/banner3.37dfd811.jpg";